import { render, staticRenderFns } from "./FilesScan.vue?vue&type=template&id=3c2c2c3b&"
import script from "./FilesScan.vue?vue&type=script&lang=js&"
export * from "./FilesScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports